export const localizedRoutes: Record<string, Record<string, string>> = {
  authorize: {
    af: "authorize",
    ar: "authorize",
    bg: "authorize",
    cs: "authorize",
    da: "authorize",
    de: "authorize",
    el: "authorize",
    en: "authorize",
    es: "authorize",
    et: "authorize",
    fi: "authorize",
    fr: "authorize",
    he: "authorize",
    hi: "authorize",
    hr: "authorize",
    hu: "authorize",
    id: "authorize",
    it: "authorize",
    ja: "authorize",
    ko: "authorize",
    lt: "authorize",
    lv: "authorize",
    ms: "authorize",
    nl: "authorize",
    no: "authorize",
    pl: "authorize",
    pt: "authorize",
    ro: "authorize",
    ru: "authorize",
    sk: "authorize",
    sl: "authorize",
    sr: "authorize",
    sv: "authorize",
    sw: "authorize",
    th: "authorize",
    tl: "authorize",
    tr: "authorize",
    uk: "authorize",
    vi: "authorize",
    zh: "authorize",
  },
  article: {
    en: "article",
  },
  articles: {
    en: "articles",
  },
  "admin-articles": {
    en: "admin-articles",
  },
  "admin-add-clients": {
    af: "admin-voeg-kliënte-by",
    ar: "admin-اضافة-عملاء",
    bg: "admin-dobavi-klienti",
    cs: "admin-pridat-klienty",
    da: "admin-tilfoej-klienter",
    de: "admin-kunden-hinzufuegen",
    el: "admin-prosthiki-pelaton",
    en: "admin-add-clients",
    es: "admin-anadir-clientes",
    et: "admin-lisa-kliendid",
    fi: "admin-lisaa-asiakkaita",
    fr: "admin-ajouter-des-clients",
    he: "admin-hosafat-lakochot",
    hi: "admin-grahak-jodna",
    hr: "admin-dodaj-klijente",
    hu: "admin-ugyfelek-hozzaadasa",
    id: "admin-tambah-klien",
    it: "admin-aggiungi-clienti",
    ja: "admin-顧客追加",
    ko: "admin-고객추가",
    lt: "admin-prideti-klientus",
    lv: "admin-pievienot-klientus",
    ms: "admin-tambah-pelanggan",
    nl: "admin-klanten-toevoegen",
    no: "admin-legge-til-kunder",
    pl: "admin-dodaj-klientow",
    pt: "admin-adicionar-clientes",
    ro: "admin-adauga-clienti",
    ru: "admin-dobavit-klientov",
    sk: "admin-pridat-klientov",
    sl: "admin-dodaj-stranke",
    sr: "admin-dodaj-klijente",
    sv: "admin-lagg-till-kunder",
    sw: "admin-ongeza-wateja",
    th: "admin-เพิ่มลูกค้า",
    tl: "admin-dagdag-kliyente",
    tr: "admin-musteri-ekle",
    uk: "admin-dodaty-klientiv",
    vi: "admin-them-khach-hang",
    zh: "admin-添加客户",
  },
  "admin-agencies-applications": {
    af: "admin-agentskap-aansoeke",
    ar: "admin-طلبات-الوكالات",
    bg: "admin-zayavleniya-za-agencii",
    cs: "admin-zadosti-agentur",
    da: "admin-agentur-ansoegninger",
    de: "admin-agentur-anfragen",
    el: "admin-aitiseis-praktoreion",
    en: "admin-agencies-applications",
    es: "admin-solicitudes-agencias",
    et: "admin-agentuuride-taotlused",
    fi: "admin-toimistojen-hakemukset",
    fr: "admin-demandes-agences",
    he: "admin-bakashot-sokhnuyot",
    hi: "admin-agency-avedan",
    hr: "admin-zahtjevi-agencija",
    hu: "admin-ugynoksegi-jelentkezesek",
    id: "admin-aplikasi-agensi",
    it: "admin-richieste-agenzie",
    ja: "admin-代理店申請",
    ko: "admin-에이전시-신청",
    lt: "admin-agenturu-paraiskos",
    lv: "admin-agenturu-pieteikumi",
    ms: "admin-permohonan-agensi",
    nl: "admin-aanvragen-agentschappen",
    no: "admin-agentur-soknader",
    pl: "admin-wnioski-agencji",
    pt: "admin-solicitacoes-agencias",
    ro: "admin-cereri-agentii",
    ru: "admin-zayavki-agentstv",
    sk: "admin-ziadosti-agentur",
    sl: "admin-prijave-agencij",
    sr: "admin-prijave-agencija",
    sv: "admin-agentur-ansokningar",
    sw: "admin-maombi-mawakala",
    th: "admin-คำขอเอเจนซี่",
    tl: "admin-mga-aplikasyon-ahensya",
    tr: "admin-ajans-basvurulari",
    uk: "admin-zayavky-agentstv",
    vi: "admin-don-dang-ky-dai-ly",
    zh: "admin-机构申请",
  },
  "admin-locations-management": {
    af: "admin-liggings-bestuur",
    ar: "admin-ادارة-المواقع",
    bg: "admin-upravlenie-na-mestopolozheniya",
    cs: "admin-sprava-lokaci",
    da: "admin-stedstyring",
    de: "admin-standorte-verwaltung",
    el: "admin-diaxeirisi-topotheision",
    en: "admin-locations-management",
    es: "admin-gestion-de-ubicaciones",
    et: "admin-asukohtade-haldus",
    fi: "admin-sijaintien-hallinta",
    fr: "admin-sites-gestion",
    he: "admin-ניהול-מיקומים",
    hi: "admin-sthan-prabandhan",
    hr: "admin-upravljanje-lokacijama",
    hu: "admin-helyszinek-kezeles",
    id: "admin-manajemen-lokasi",
    it: "admin-gestione-posizioni",
    ja: "admin-ロケーション管理",
    ko: "admin-위치-관리",
    lt: "admin-vietu-valdymas",
    lv: "admin-atrašanās-vietu-parvaldiba",
    ms: "admin-pengurusan-lokasi",
    nl: "admin-locatiebeheer",
    no: "admin-styring-av-steder",
    pl: "admin-zarzadzanie-lokalizacjami",
    pt: "admin-gestao-de-locais",
    ro: "admin-locatii-management",
    ru: "admin-upravlenie-lokaciyami",
    sk: "admin-sprava-lokacii",
    sl: "admin-upravljanje-lokacij",
    sr: "admin-upravljanje-lokacijama",
    sv: "admin-hantering-av-platser",
    sw: "admin-usimamizi-wa-maeneo",
    th: "admin-การจัดการสถานที่",
    tl: "admin-pamamahala-ng-lokasyon",
    tr: "admin-konum-yonetimi",
    uk: "admin-upravlinnya-lokatsiyamy",
    vi: "admin-quan-ly-dia-diem",
    zh: "admin-位置管理",
  },
  agency: {
    af: "agentskap",
    ar: "وكالة",
    bg: "agenciya",
    cs: "agentura",
    da: "agentur",
    de: "agentur",
    el: "praktoreio",
    en: "agency",
    es: "agencia",
    et: "agentuur",
    fi: "toimisto",
    fr: "agence",
    he: "סוכנות",
    hi: "ejensi",
    hr: "agencija",
    hu: "ugynokseg",
    id: "agensi-properti",
    it: "agenzia",
    ja: "不動産会社",
    ko: "대리점",
    lt: "agentura",
    lv: "agentura",
    ms: "agensi-hartanah",
    nl: "agentschap",
    no: "byra",
    pl: "agencja",
    pt: "agencia",
    ro: "agentie",
    ru: "agentstvo",
    sk: "agentura",
    sl: "agencija",
    sr: "agencija",
    sv: "byra",
    sw: "mawakala-ya-mali",
    th: "ตัวแทน",
    tl: "ahensya",
    tr: "ajans",
    uk: "agentstvo",
    vi: "dai-ly",
    zh: "代理",
  },
  "agency-profile": {
    af: "agentskap-profiel",
    ar: "ملف-الوكالة",
    bg: "profil-na-agenciyata",
    cs: "profil-agentury",
    da: "bureauprofil",
    de: "agenturprofil",
    el: "profil-agenias",
    en: "agency-profile",
    es: "perfil-de-agencia",
    et: "agentuuri-profiil",
    fi: "toimiston-profiili",
    fr: "profil-agence",
    he: "פרופיל-הסוכנות",
    hi: "agency-profayl",
    hr: "profil-agencije",
    hu: "ugynokseg-profil",
    id: "profil-agensi",
    it: "profilo-agenzia",
    ja: "代理店プロフィール",
    ko: "에이전시-프로필",
    lt: "agenturos-profilis",
    lv: "agenturas-profils",
    ms: "profil-agensi",
    nl: "agentschap-profiel",
    no: "byraprofil",
    pl: "profil-agencji",
    pt: "perfil-da-agencia",
    ro: "profil-agentie",
    ru: "profil-agentstva",
    sk: "profil-agentury",
    sl: "profil-agencije",
    sr: "profil-agencije",
    sv: "byraprofil",
    sw: "wasifu-wa-taasisi",
    th: "โปรไฟล์-ตัวแทน",
    tl: "profile-ng-ahensya",
    tr: "ajans-profili",
    uk: "profil-agenstvi",
    vi: "ho-so-dai-ly",
    zh: "代理机构简介",
  },
  chats: {
    af: "geselsies",
    ar: "دردشات",
    bg: "chatove",
    cs: "chaty",
    da: "chats",
    de: "chats",
    el: "syzitiseis",
    en: "chats",
    es: "chats",
    et: "vestlused",
    fi: "keskustelut",
    fr: "discussions",
    he: "צאטים",
    hi: "chats",
    hr: "razgovori",
    hu: "beszelgetesek",
    id: "obrolan",
    it: "chat",
    ja: "チャット",
    ko: "채팅",
    lt: "poklabiai",
    lv: "sarunas",
    ms: "sembang",
    nl: "chats",
    no: "samtaler",
    pl: "czaty",
    pt: "chats",
    ro: "conversatii",
    ru: "chati",
    sk: "chaty",
    sl: "klepeti",
    sr: "cetovi",
    sv: "chattar",
    sw: "mazungumzo",
    th: "แชท",
    tl: "usap",
    tr: "sohbetler",
    uk: "chati",
    vi: "tro-chuyen",
    zh: "聊天",
  },
  contact: {
    af: "kontak",
    ar: "اتصال",
    bg: "kontakt",
    cs: "kontakt",
    da: "kontakt",
    de: "kontakt",
    el: "epikoinonia",
    en: "contact",
    es: "contacto",
    et: "kontakt",
    fi: "yhteystiedot",
    fr: "contact",
    he: "צור-קשר",
    hi: "sampark",
    hr: "kontakt",
    hu: "kapcsolat",
    id: "kontak",
    it: "contatto",
    ja: "連絡",
    ko: "연락처",
    lt: "kontaktas",
    lv: "kontakts",
    ms: "hubungi",
    nl: "contact",
    no: "kontakt",
    pl: "kontakt",
    pt: "contato",
    ro: "contact",
    ru: "kontakt",
    sk: "kontakt",
    sl: "kontakt",
    sr: "kontakt",
    sv: "kontakt",
    sw: "mawasiliano",
    th: "ติดต่อ",
    tl: "kontak",
    tr: "iletisim",
    uk: "kontakt",
    vi: "lien-he",
    zh: "联系",
  },
  "cookies-policy": {
    af: "koekiesbeleid",
    ar: "سياسة-ملفات-الارتباط",
    bg: "politika-za-biskvitki",
    cs: "zasady-cookies",
    da: "cookiepolitik",
    de: "cookie-richtlinie",
    el: "politiki-cookies",
    en: "cookies-policy",
    es: "politica-de-cookies",
    et: "kupsiste-poliitika",
    fi: "evastekaytanto",
    fr: "politique-cookies",
    he: "מדיניות-קוקיז",
    hi: "kukis-neeti",
    hr: "politika-kolacica",
    hu: "sutik-szabalyzat",
    id: "kebijakan-cookie",
    it: "politica-cookie",
    ja: "クッキーポリシー",
    ko: "쿠키-정책",
    lt: "sausainiu-politika",
    lv: "sikdatnu-politika",
    ms: "dasar-kuki",
    nl: "cookiebeleid",
    no: "informasjonskapsel-policy",
    pl: "polityka-cookies",
    pt: "politica-de-cookies",
    ro: "politica-cookies",
    ru: "politika-faylov-cookie",
    sk: "zasady-suborov-cookie",
    sl: "politika-piskotkov",
    sr: "politika-kolacica",
    sv: "cookiepolicy",
    sw: "sera-ya-kuki",
    th: "นโยบาย-คุกกี้",
    tl: "patakaran-sa-cookies",
    tr: "cerez-politikasi",
    uk: "polityka-cookie",
    vi: "chinh-sach-cookie",
    zh: "Cookie政策",
  },
  listing: {
    af: "lys",
    ar: "اعلان",
    bg: "obyava",
    cs: "inzerat",
    da: "opslag",
    de: "anzeige",
    el: "aggelia",
    en: "listing",
    es: "anuncio",
    et: "kuulutus",
    fi: "ilmoitus",
    fr: "annonce",
    he: "מודעה",
    hi: "soochi",
    hr: "oglas",
    hu: "hirdetes",
    id: "daftar",
    it: "annuncio",
    ja: "掲載",
    ko: "매물",
    lt: "skelbimas",
    lv: "sludinajums",
    ms: "senarai",
    nl: "advertentie",
    no: "annonse",
    pl: "ogloszenie",
    pt: "anuncio",
    ro: "anunt",
    ru: "obyavlenie",
    sk: "inzerat",
    sl: "oglas",
    sr: "oglas",
    sv: "annons",
    sw: "tangazo",
    th: "ประกาศ",
    tl: "anunsyo",
    tr: "ilan",
    uk: "ogoloshennya",
    vi: "tin-dang",
    zh: "房源",
  },
  "my-account": {
    af: "my-rekening",
    ar: "حسابي",
    bg: "moyat-profil",
    cs: "muj-ucet",
    da: "min-konto",
    de: "mein-konto",
    el: "o-logariasmos-mou",
    en: "my-account",
    es: "mi-cuenta",
    et: "minu-konto",
    fi: "oma-tili",
    fr: "mon-compte",
    he: "החשבון-שלי",
    hi: "mera-khata",
    hr: "moj-racun",
    hu: "fiokom",
    id: "akun-saya",
    it: "mio-account",
    ja: "マイアカウント",
    ko: "내-계정",
    lt: "mano-paskyra",
    lv: "mans-konts",
    ms: "akaun-saya",
    nl: "mijn-account",
    no: "min-konto",
    pl: "moje-konto",
    pt: "minha-conta",
    ro: "contul-meu",
    ru: "moy-akkaunt",
    sk: "moj-ucet",
    sl: "moj-racun",
    sr: "moj-nalog",
    sv: "mitt-konto",
    sw: "akaunti-yangu",
    th: "บัญชีของฉัน",
    tl: "aking-account",
    tr: "hesabim",
    uk: "miy-akaunt",
    vi: "tai-khoan-cua-toi",
    zh: "我的账户",
  },
  "my-listings": {
    af: "my-lys",
    ar: "قوائمي",
    bg: "moite-obiavi",
    cs: "me-inzeraty",
    da: "mine-opslag",
    de: "meine-anzeigen",
    el: "oi-aggelies-mou",
    en: "my-listings",
    es: "mis-anuncios",
    et: "minu-kuulutused",
    fi: "omat-ilmoitukset",
    fr: "mes-annonces",
    he: "הרשימות-שלי",
    hi: "mere-suchiyan",
    hr: "moji-oglasi",
    hu: "hirdeteseim",
    id: "daftar-saya",
    it: "i-miei-annunci",
    ja: "マイリスティング",
    ko: "내-리스트",
    lt: "mano-skelbimai",
    lv: "mani-sludinajumi",
    ms: "senarai-saya",
    nl: "mijn-advertenties",
    no: "mine-annonser",
    pl: "moje-ogloszenia",
    pt: "meus-anuncios",
    ro: "anunturile-mele",
    ru: "moi-obyavleniya",
    sk: "moje-inzeraty",
    sl: "moji-oglasi",
    sr: "moji-oglasi",
    sv: "mina-annonser",
    sw: "matangazo-yangu",
    th: "ประกาศของฉัน",
    tl: "aking-listahan",
    tr: "ilanlarim",
    uk: "moi-ogoloshennya",
    vi: "tin-dang-cua-toi",
    zh: "我的列表",
  },
  "new-listing": {
    af: "nuwe-lys",
    ar: "اعلان-جديد",
    bg: "nova-obiava",
    cs: "novy-inzerat",
    da: "ny-opslag",
    de: "neue-anzeige",
    el: "nea-aggelia",
    en: "new-listing",
    es: "nuevo-anuncio",
    et: "uus-kuulutus",
    fi: "uusi-ilmoitus",
    fr: "nouvelle-annonce",
    he: "רשימה-חדשה",
    hi: "nayi-suchi",
    hr: "novi-oglas",
    hu: "uj-hirdetes",
    id: "daftar-baru",
    it: "nuovo-annuncio",
    ja: "新しいリスティング",
    ko: "새-리스트",
    lt: "naujas-skelbimas",
    lv: "jauns-sludinajums",
    ms: "senarai-baru",
    nl: "nieuwe-advertentie",
    no: "ny-annonse",
    pl: "nowe-ogloszenie",
    pt: "novo-anuncio",
    ro: "anunt-nou",
    ru: "novoe-obyavlenie",
    sk: "novy-inzerat",
    sl: "novi-oglas",
    sr: "novi-oglas",
    sv: "ny-annons",
    sw: "tangazo-jipya",
    th: "ประกาศใหม่",
    tl: "bagong-listahan",
    tr: "yeni-ilan",
    uk: "nova-ogoloshennya",
    vi: "tin-dang-moi",
    zh: "新列表",
  },
  payment: {
    af: "betaling",
    ar: "الدفع",
    bg: "plashtane",
    cs: "platba",
    da: "betaling",
    de: "zahlung",
    el: "pliromi",
    en: "payment",
    es: "pago",
    et: "makse",
    fi: "maksu",
    fr: "paiement",
    he: "תשלום",
    hi: "bhugtan",
    hr: "placanje",
    hu: "fizetes",
    id: "pembayaran",
    it: "pagamento",
    ja: "支払い",
    ko: "결제",
    lt: "mokejimas",
    lv: "maksajums",
    ms: "bayaran",
    nl: "betaling",
    no: "betaling",
    pl: "platnosc",
    pt: "pagamento",
    ro: "plata",
    ru: "oplata",
    sk: "platba",
    sl: "placilo",
    sr: "placanje",
    sv: "betalning",
    sw: "malipo",
    th: "ชำระเงิน",
    tl: "bayad",
    tr: "odeme",
    uk: "oplata",
    vi: "thanh-toan",
    zh: "支付",
  },
  publish: {
    af: "publiseer",
    ar: "نشر",
    bg: "publikuvane",
    cs: "zverejnit",
    da: "udgiv",
    de: "veroffentlichen",
    el: "dimosieusi",
    en: "publish",
    es: "publicar",
    et: "avaldada",
    fi: "julkaista",
    fr: "publier",
    he: "לפרסם",
    hi: "prakashit-karo",
    hr: "objaviti",
    hu: "kozzetenni",
    id: "terbitkan",
    it: "pubblicare",
    ja: "公開する",
    ko: "게시하다",
    lt: "paskelbti",
    lv: "publicet",
    ms: "terbitkan",
    nl: "publiceren",
    no: "publisere",
    pl: "opublikowac",
    pt: "publicar",
    ro: "publica",
    ru: "opublikovat",
    sk: "zverejnit",
    sl: "objaviti",
    sr: "objaviti",
    sv: "publicera",
    sw: "chapisha",
    th: "เผยแพร่",
    tl: "ilathala",
    tr: "yayinla",
    uk: "opublikuvati",
    vi: "xuat-ban",
    zh: "發布",
  },
  pricing: {
    af: "pryse",
    ar: "اسعار",
    bg: "tseni",
    cs: "cenik",
    da: "priser",
    de: "preise",
    el: "times",
    en: "pricing",
    es: "precios",
    et: "hinnad",
    fi: "hinnasto",
    fr: "prix",
    he: "מחירים",
    hi: "moolya",
    hr: "cijene",
    hu: "arak",
    id: "harga",
    it: "prezzi",
    ja: "価格",
    ko: "가격",
    lt: "kainos",
    lv: "cenas",
    ms: "harga",
    nl: "prijzen",
    no: "priser",
    pl: "ceny",
    pt: "precos",
    ro: "preturi",
    ru: "tseny",
    sk: "cennik",
    sl: "cene",
    sr: "cene",
    sv: "priser",
    sw: "bei",
    th: "ราคา",
    tl: "presyo",
    tr: "fiyatlar",
    uk: "tsiny",
    vi: "bang-gia",
    zh: "價格",
  },
  "agency-pricing": {
    af: "agentskap-pryse",
    ar: "تسعير-الوكالة",
    bg: "agentski-tseni",
    cs: "cenik-agentury",
    da: "agentur-priser",
    de: "agentur-preise",
    el: "times-praktoreiou",
    en: "agency-pricing",
    es: "precios-agencia",
    et: "agentuuri-hinnad",
    fi: "toimisto-hinnasto",
    fr: "tarifs-agence",
    he: "תמחור-סוכנות",
    hi: "agency-moolya",
    hr: "agencijske-cijene",
    hu: "ugynoksegi-arak",
    id: "harga-agency",
    it: "prezzi-agenzia",
    ja: "代理店-価格",
    ko: "에이전시-가격",
    lt: "agenturos-kainos",
    lv: "agenturas-cenas",
    ms: "harga-agensi",
    nl: "bureau-prijzen",
    no: "byra-priser",
    pl: "ceny-agencji",
    pt: "precos-agencia",
    ro: "preturi-agentie",
    ru: "agentskie-tseny",
    sk: "cennik-agentury",
    sl: "agencijske-cene",
    sr: "agencijske-cene",
    sv: "byra-priser",
    sw: "bei-shirika",
    th: "ราคา-ตัวแทน",
    tl: "presyo-ahensya",
    tr: "ajans-fiyatlar",
    uk: "tsiny-ahentstva",
    vi: "bang-gia-dai-ly",
    zh: "代理-價格",
  },
  "privacy-policy": {
    af: "privaatheidsbeleid",
    ar: "سياسة-الخصوصية",
    bg: "politika-za-poveritelnost",
    cs: "zasady-ochrany-osobnich-udaju",
    da: "privatlivspolitik",
    de: "datenschutzrichtlinie",
    el: "politiki-aporritou",
    en: "privacy-policy",
    es: "politica-de-privacidad",
    et: "privaatsuspoliitika",
    fi: "tietosuojakaytanto",
    fr: "politique-confidentialite",
    he: "מדיניות-פרטיות",
    hi: "gopniyata-neeti",
    hr: "politika-privatnosti",
    hu: "adatvedelmi-iranyelvek",
    id: "kebijakan-privasi",
    it: "informativa-privacy",
    ja: "プライバシーポリシー",
    ko: "개인정보-처리방침",
    lt: "privatumo-politika",
    lv: "privatuma-politika",
    ms: "dasar-privasi",
    nl: "privacybeleid",
    no: "personvernregler",
    pl: "polityka-prywatnosci",
    pt: "politica-de-privacidade",
    ro: "politica-confidentialitate",
    ru: "politika-konfidentsialnosti",
    sk: "zasady-ochrany-osobnych-udajov",
    sl: "politika-zasebnosti",
    sr: "politika-privatnosti",
    sv: "integritetspolicy",
    sw: "sera-ya-faragha",
    th: "นโยบาย-ความเป็นส่วนตัว",
    tl: "patakaran-sa-privacy",
    tr: "gizlilik-politikasi",
    uk: "polityka-konfidentsiinosti",
    vi: "chinh-sach-bao-mat",
    zh: "隐私政策",
  },
  profiles: {
    af: "profiele",
    ar: "ملفات-التعريف",
    bg: "profili",
    cs: "profily",
    da: "profiler",
    de: "profile",
    el: "profil",
    en: "profiles",
    es: "perfiles",
    et: "profiilid",
    fi: "profiilit",
    fr: "profils",
    he: "פרופילים",
    hi: "parichay",
    hr: "profili",
    hu: "profilok",
    id: "profil",
    it: "profili",
    ja: "プロフィール",
    ko: "프로필",
    lt: "profiliai",
    lv: "profili",
    ms: "profil",
    nl: "profielen",
    no: "profiler",
    pl: "profile",
    pt: "perfis",
    ro: "profiluri",
    ru: "profili",
    sk: "profily",
    sl: "profili",
    sr: "profili",
    sv: "profiler",
    sw: "wasifu",
    th: "โปรไฟล์",
    tl: "mga-profil",
    tr: "profiller",
    uk: "profili",
    vi: "ho-so",
    zh: "个人资料",
  },
  "refund-policy": {
    af: "terugbetalingsbeleid",
    ar: "سياسة-الاسترداد",
    bg: "politika-za-vuzstanovyavane",
    cs: "zasady-vraceni-penez",
    da: "refusionspolitik",
    de: "erstattungsrichtlinie",
    el: "politiki-epistrofon",
    en: "refund-policy",
    es: "politica-de-reembolso",
    et: "tagastuspoliitika",
    fi: "hyvityskaytanto",
    fr: "politique-remboursement",
    he: "מדיניות-החזרים",
    hi: "rifund-neeti",
    hr: "politika-povrata",
    hu: "visszateritesi-szabalyzat",
    id: "kebijakan-pengembalian",
    it: "politica-rimborso",
    ja: "返金ポリシー",
    ko: "환불-정책",
    lt: "grazinimo-politika",
    lv: "atgriesanas-politika",
    ms: "dasar-bayaran-balik",
    nl: "restitutiebeleid",
    no: "refusjonspolicy",
    pl: "polityka-zwrotow",
    pt: "politica-de-reembolso",
    ro: "politica-rambursare",
    ru: "politika-vozvrata-deneg",
    sk: "zasady-vratenia-penazi",
    sl: "politika-vracila",
    sr: "politika-povrata",
    sv: "aterbetalningspolicy",
    sw: "sera-ya-marejesho",
    th: "นโยบาย-การคืนเงิน",
    tl: "patakaran-sa-refund",
    tr: "iade-politikasi",
    uk: "polityka-povernen-groshey",
    vi: "chinh-sach-hoan-tien",
    zh: "退款政策",
  },
  "saved-listings": {
    af: "gestoorde-lyste",
    ar: "القوائم-المحفوظة",
    bg: "zapisani-obiavi",
    cs: "ulozene-inzeraty",
    da: "gemte-opslag",
    de: "gespeicherte-anzeigen",
    el: "apothikevmenes-aggelies",
    en: "saved-listings",
    es: "anuncios-guardados",
    et: "salvestatud-kuulutused",
    fi: "tallennetut-ilmoitukset",
    fr: "annonces-enregistrees",
    he: "מודעות-שמורות",
    hi: "surakshit-suchiyan",
    hr: "spremeljeni-oglasi",
    hu: "mentett-hirdetesek",
    id: "daftar-disimpan",
    it: "annunci-salvati",
    ja: "保存したリスト",
    ko: "저장된-목록",
    lt: "issaugoti-skelbimai",
    lv: "saglabatie-sludinajumi",
    ms: "senarai-disimpan",
    nl: "opgeslagen-advertenties",
    no: "lagrede-annonser",
    pl: "zapisane-ogloszenia",
    pt: "anuncios-salvos",
    ro: "anunturi-salvate",
    ru: "sohranennye-obyavleniya",
    sk: "ulozene-inzeraty",
    sl: "shranjeni-oglasi",
    sr: "sacuvani-oglasi",
    sv: "sparade-annonser",
    sw: "orodha-zilizohifadhiwa",
    th: "ประกาศที่บันทึกไว้",
    tl: "mga-nakatipid-na-listahan",
    tr: "kaydedilen-ilanlar",
    uk: "zberezheni-ogoloshennya",
    vi: "danh-sach-da-luu",
    zh: "保存的列表",
  },
  search: {
    af: "soek",
    ar: "بحث",
    bg: "tarsene",
    cs: "hledani",
    da: "soeg",
    de: "suche",
    el: "anazitisi",
    en: "search",
    es: "busqueda",
    et: "otsing",
    fi: "haku",
    fr: "recherche",
    he: "חיפוש",
    hi: "khoj",
    hr: "pretraga",
    hu: "kereses",
    id: "pencarian",
    it: "ricerca",
    ja: "検索",
    ko: "검색",
    lt: "paieska",
    lv: "meklesana",
    ms: "carian",
    nl: "zoeken",
    no: "sok",
    pl: "wyszukiwanie",
    pt: "pesquisa",
    ro: "cautare",
    ru: "poisk",
    sk: "hladanie",
    sl: "iskanje",
    sr: "pretraga",
    sv: "sok",
    sw: "tafuta",
    th: "ค้นหา",
    tl: "paghahanap",
    tr: "arama",
    uk: "poshuk",
    vi: "tim-kiem",
    zh: "搜索",
  },
  "terms-of-use": {
    af: "gebruiksvoorwaardes",
    ar: "شروط-الاستخدام",
    bg: "uslovija-za-polzvane",
    cs: "podminky-pouziti",
    da: "brugsbetingelser",
    de: "nutzungsbedingungen",
    el: "oroi-chrisis",
    en: "terms-of-use",
    es: "condiciones-uso",
    et: "kasutustingimused",
    fi: "kayttoehdot",
    fr: "conditions-utilisation",
    he: "תנאי-שימוש",
    hi: "upyog-sharten",
    hr: "uvjeti-koristenja",
    hu: "felhasznalasi-feltetelek",
    id: "syarat-penggunaan",
    it: "termini-utilizzo",
    ja: "利用規約",
    ko: "이용약관",
    lt: "naudojimo-salygos",
    lv: "lietosanas-noteikumi",
    ms: "terma-penggunaan",
    nl: "gebruiksvoorwaarden",
    no: "bruksvilkar",
    pl: "warunki-korzystania",
    pt: "termos-uso",
    ro: "conditii-utilizare",
    ru: "uslovija-ispolzovanija",
    sk: "podmienky-pouzivania",
    sl: "pogoji-uporabe",
    sr: "uslovi-koriscenja",
    sv: "anvandarvillkor",
    sw: "vigezo-masharti-matumizi",
    th: "ข้อตกลงการใช้งาน",
    tl: "mga-tuntunin-paggamit",
    tr: "kullanim-sartlari",
    uk: "umovi-vikoristannja",
    vi: "dieu-khoan-su-dung",
    zh: "使用条款",
  },
  home: {
    af: "",
    ar: "",
    bg: "",
    cs: "",
    da: "",
    de: "",
    el: "",
    en: "",
    es: "",
    et: "",
    fi: "",
    fr: "",
    he: "",
    hi: "",
    hr: "",
    hu: "",
    id: "",
    it: "",
    ja: "",
    ko: "",
    lt: "",
    lv: "",
    ms: "",
    nl: "",
    no: "",
    pl: "",
    pt: "",
    ro: "",
    ru: "",
    sk: "",
    sl: "",
    sr: "",
    sv: "",
    sw: "",
    th: "",
    tl: "",
    tr: "",
    uk: "",
    vi: "",
    zh: "",
  },
  country: {
    af: "",
    ar: "",
    bg: "",
    cs: "",
    da: "",
    de: "",
    el: "",
    en: "",
    es: "",
    et: "",
    fi: "",
    fr: "",
    he: "",
    hi: "",
    hr: "",
    hu: "",
    id: "",
    it: "",
    ja: "",
    ko: "",
    lt: "",
    lv: "",
    ms: "",
    nl: "",
    no: "",
    pl: "",
    pt: "",
    ro: "",
    ru: "",
    sk: "",
    sl: "",
    sr: "",
    sv: "",
    sw: "",
    th: "",
    tl: "",
    tr: "",
    uk: "",
    vi: "",
    zh: "",
  },
  dashboard: {
    af: "dashboard",
    ar: "dashboard",
    bg: "dashboard",
    cs: "dashboard",
    da: "dashboard",
    de: "dashboard",
    el: "dashboard",
    en: "dashboard",
    es: "dashboard",
    et: "dashboard",
    fi: "dashboard",
    fr: "dashboard",
    he: "dashboard",
    hi: "dashboard",
    hr: "dashboard",
    hu: "dashboard",
    id: "dashboard",
    it: "dashboard",
    ja: "dashboard",
    ko: "dashboard",
    lt: "dashboard",
    lv: "dashboard",
    ms: "dashboard",
    nl: "dashboard",
    no: "dashboard",
    pl: "dashboard",
    pt: "dashboard",
    ro: "dashboard",
    ru: "dashboard",
    sk: "dashboard",
    sl: "dashboard",
    sr: "dashboard",
    sv: "dashboard",
    sw: "dashboard",
    th: "dashboard",
    tl: "dashboard",
    tr: "dashboard",
    uk: "dashboard",
    vi: "dashboard",
    zh: "dashboard",
  },
  locations: {
    af: "liggings",
    ar: "مواقع",
    bg: "lokacii",
    cs: "lokality",
    da: "steder",
    de: "standorte",
    el: "topothesies",
    en: "locations",
    es: "ubicaciones",
    et: "asukohad",
    fi: "sijainnit",
    fr: "lieux",
    he: "מיקומים",
    hi: "sthan",
    hr: "lokacije",
    hu: "helyszinek",
    id: "lokasi",
    it: "localita",
    ja: "ロケーション",
    ko: "위치",
    lt: "vietos",
    lv: "vietas",
    ms: "lokasi",
    nl: "locaties",
    no: "steder",
    pl: "lokalizacje",
    pt: "localizacoes",
    ro: "locatii",
    ru: "lokatsii",
    sk: "lokality",
    sl: "lokacije",
    sr: "lokacije",
    sv: "platser",
    sw: "maeneo",
    th: "สถานที่",
    tl: "mga-lokasyon",
    tr: "konumlar",
    uk: "lokatsiyi",
    vi: "dia-diem",
    zh: "地点",
  },
  agents: {
    af: "agente",
    ar: "وكلاء",
    bg: "agenti",
    cs: "makleri",
    da: "maeglere",
    de: "makler",
    el: "mesites",
    en: "agents",
    es: "agentes",
    et: "maaklerid",
    fi: "valittajat",
    fr: "agents",
    he: "סוכנים",
    hi: "dalal",
    hr: "agenti",
    hu: "ugynokok",
    id: "agen",
    it: "agenti",
    ja: "エージェント",
    ko: "에이전트",
    lt: "agentai",
    lv: "agenti",
    ms: "ejen",
    nl: "makelaars",
    no: "meglere",
    pl: "agenci",
    pt: "agentes",
    ro: "agenti",
    ru: "agenty",
    sk: "makleri",
    sl: "agenti",
    sr: "agenti",
    sv: "maklare",
    sw: "mawakala",
    th: "ตัวแทน",
    tl: "mga-ahente",
    tr: "emlak-danismanlari",
    uk: "agenty",
    vi: "moi-gioi",
    zh: "经纪人",
  },
  agencies: {
    af: "agentskappe",
    ar: "وكالات",
    bg: "agencii",
    cs: "agentury",
    da: "bureauer",
    de: "maklerbueros",
    el: "praktoreia",
    en: "agencies",
    es: "agencias",
    et: "agentuurid",
    fi: "toimistot",
    fr: "agences",
    he: "סוכנויות",
    hi: "ejensiyan",
    hr: "agencije",
    hu: "ugynoksegek",
    id: "agensi",
    it: "agenzie",
    ja: "代理店",
    ko: "에이전시",
    lt: "agenturos",
    lv: "agenturas",
    ms: "agensi",
    nl: "agentschappen",
    no: "byraer",
    pl: "agencje",
    pt: "agencias",
    ro: "agentii",
    ru: "agentstva",
    sk: "agentury",
    sl: "agencije",
    sr: "agencije",
    sv: "byraer",
    sw: "wakala",
    th: "เอเจนซี่",
    tl: "mga-ahensya",
    tr: "emlak-ofisleri",
    uk: "agentstva",
    vi: "dai-ly",
    zh: "机构",
  },
  collections: {
    af: "versamelings",
    ar: "مجموعات",
    bg: "kolekcii",
    cs: "kolekce",
    da: "samlinger",
    de: "kollektionen",
    el: "sylloges",
    en: "collections",
    es: "colecciones",
    et: "kollektsioonid",
    fi: "kokoelmat",
    fr: "collections",
    he: "אוספים",
    hi: "sangrah",
    hr: "kolekcije",
    hu: "gyujtemenyek",
    id: "koleksi",
    it: "collezioni",
    ja: "コレクション",
    ko: "컬렉션",
    lt: "kolekcijos",
    lv: "kolekcijas",
    ms: "koleksi",
    nl: "collecties",
    no: "samlinger",
    pl: "kolekcje",
    pt: "colecoes",
    ro: "colectii",
    ru: "kollekcii",
    sk: "kolekcie",
    sl: "zbirke",
    sr: "kolekcije",
    sv: "samlingar",
    sw: "mikusanyiko",
    th: "คอลเลกชัน",
    tl: "mga-koleksyon",
    tr: "koleksiyonlar",
    uk: "kolektsiyi",
    vi: "bo-suu-tap",
    zh: "精选集",
  },
  "international-real-estate": {
    af: "internasionale-vaste-eiendom",
    ar: "عقارات-دولية",
    bg: "mezhdunarodni-imoti",
    cs: "mezinarodni-nemovitosti",
    da: "international-ejendom",
    de: "internationale-immobilien",
    el: "diethni-akinita",
    en: "international-real-estate",
    es: "inmobiliaria-internacional",
    et: "rahvusvaheline-kinnisvara",
    fi: "kansainvaliset-kiinteistot",
    fr: "immobilier-international",
    he: "נדלן-בינלאומי",
    hi: "antarashtriya-real-estate",
    hr: "medunarodne-nekretnine",
    hu: "nemzetkozi-ingatlanok",
    id: "properti-internasional",
    it: "immobiliare-internazionale",
    ja: "国際不動産",
    ko: "국제부동산",
    lt: "tarptautinis-nekilnojamasis-turtas",
    lv: "starptautiskais-nekustamais-ipasums",
    ms: "hartanah-antarabangsa",
    nl: "internationaal-vastgoed",
    no: "internasjonal-eiendom",
    pl: "nieruchomosci-miedzynarodowe",
    pt: "imobiliario-internacional",
    ro: "imobiliare-internationale",
    ru: "mezhdunarodnaya-nedvizhimost",
    sk: "medzinarodne-nehnutelnosti",
    sl: "mednarodne-nepremicnine",
    sr: "medunarodne-nekretnine",
    sv: "internationella-fastigheter",
    sw: "mali-isiyohamishika-kimataifa",
    th: "อสังหาริมทรัพย์นานาชาติ",
    tl: "internasyonal-na-real-estate",
    tr: "uluslararasi-emlak",
    uk: "mizhnarodna-neruhomist",
    vi: "bat-dong-san-quoc-te",
    zh: "国际房地产",
  },
};

export const newListingSubRoutes: Record<string, Record<string, string>> = {
  publish: {
    af: "publiseer",
    ar: "نشر",
    bg: "publikuvaite",
    cs: "zverejnit",
    da: "udgiv",
    de: "veroffentlichen",
    el: "dimosieuse",
    en: "publish",
    es: "publicar",
    et: "avalda",
    fi: "julkaise",
    fr: "publier",
    he: "פרסם",
    hi: "prakashit",
    hr: "objavi",
    hu: "kozzetesz",
    id: "terbitkan",
    it: "pubblica",
    ja: "公開",
    ko: "게시",
    lt: "publikuoti",
    lv: "publicet",
    ms: "terbit",
    nl: "publiceren",
    no: "publiser",
    pl: "opublikuj",
    pt: "publicar",
    ro: "publica",
    ru: "opublikovat",
    sk: "zverejnit",
    sl: "objavi",
    sr: "objavi",
    sv: "publicera",
    sw: "chapisha",
    th: "เผยแพร่",
    tl: "ilathala",
    tr: "yayinla",
    uk: "opublikuvati",
    vi: "dang",
    zh: "发布",
  },
};

export const myListingsSubRoutes: Record<string, Record<string, string>> = {
  edit: {
    af: "wysig",
    ar: "تعديل",
    bg: "redaktirai",
    cs: "upravit",
    da: "rediger",
    de: "bearbeiten",
    el: "epexergasia",
    en: "edit",
    es: "editar",
    et: "muuda",
    fi: "muokkaa",
    fr: "modifier",
    he: "ערוך",
    hi: "sampadit",
    hr: "uredi",
    hu: "szerkeszt",
    id: "edit",
    it: "modifica",
    ja: "編集",
    ko: "편집",
    lt: "redaguoti",
    lv: "rediget",
    ms: "sunting",
    nl: "bewerken",
    no: "rediger",
    pl: "edytuj",
    pt: "editar",
    ro: "editeaza",
    ru: "redaktirovat",
    sk: "uprav",
    sl: "uredi",
    sr: "uredi",
    sv: "redigera",
    sw: "hariri",
    th: "แก้ไข",
    tl: "i-edit",
    tr: "duzenle",
    uk: "redahuvati",
    vi: "chinh-sua",
    zh: "编辑",
  },
};
export const agencySubRoutes: Record<string, Record<string, string>> = {
  "accept-invitation": {
    af: "aanvaar-uitnodiging",
    ar: "قبول-الدعوة",
    bg: "priemi pokana",
    cs: "prijmout-pozvanku",
    da: "accepter-invitation",
    de: "einladung-annehmen",
    el: "dexou-prosklisi",
    en: "accept-invitation",
    es: "aceptar-invitacion",
    et: "noustu-kutse",
    fi: "hyvaksy-kutsu",
    fr: "accepter-invitation",
    he: "קבל-הזמנה",
    hi: "nimantran-svikar",
    hr: "prihvati-pozivnicu",
    hu: "meghivas-elfogadasa",
    id: "terima-undangan",
    it: "accetta-invito",
    ja: "招待を承諾",
    ko: "초대-수락",
    lt: "priimti-kvietima",
    lv: "pienemt-iuzskumu",
    ms: "terima-jemputan",
    nl: "uitnodiging-accepteren",
    no: "godta-invitasjon",
    pl: "zaakceptuj-zaproszenie",
    pt: "aceitar-convite",
    ro: "accepta-invitatie",
    ru: "prinyat-priglashenie",
    sk: "prijat-pozvanku",
    sl: "sprejmi-vabilo",
    sr: "prihvati-pozivnicu",
    sv: "acceptera-inbjudan",
    sw: "kubali-mwaliko",
    th: "ยอมรับคำเชิญ",
    tl: "tanggapin-imbitasyon",
    tr: "davetiye-kabul-et",
    uk: "pryiniaty-zaproshennya",
    vi: "chap-nhan-loi-moi",
    zh: "接受邀请",
  },
};

export const dynamicSlugTranslations: Record<
  string,
  Record<string, Record<string, string>>
> = {
  purpose: {
    "for-sale": {
      af: "te-koop",
      ar: "للبيع",
      bg: "za-prodazhba",
      cs: "na-prodej",
      da: "til-salg",
      de: "zum-verkauf",
      el: "pros-polisi",
      en: "for-sale",
      es: "en-venta",
      et: "muugil",
      fi: "myytavana",
      fr: "a-vendre",
      he: "למכירה",
      hi: "bikri-ke-liye",
      hr: "na-prodaju",
      hu: "elado",
      id: "dijual",
      it: "in-vendita",
      ja: "販売中",
      ko: "판매중",
      lt: "parduodama",
      lv: "pardod",
      ms: "untuk-dijual",
      nl: "te-koop",
      no: "til-salgs",
      pl: "na-sprzedaz",
      pt: "a-venda",
      ro: "de-vanzare",
      ru: "na-prodazhu",
      sk: "na-predaj",
      sl: "naprodaj",
      sr: "na-prodaju",
      sv: "till-salu",
      sw: "inauzwa",
      th: "ขาย",
      tl: "ibinebenta",
      tr: "satilik",
      uk: "na-prodazh",
      vi: "dang-ban",
      zh: "出售",
    },
    "for-rent": {
      af: "te-huur",
      ar: "للإيجار",
      bg: "pod-naem",
      cs: "k-pronajmu",
      da: "til-leje",
      de: "zu-vermieten",
      el: "pros-enoikiash",
      en: "for-rent",
      es: "en-alquiler",
      et: "uurile",
      fi: "vuokrattavana",
      fr: "a-louer",
      he: "להשכרה",
      hi: "kiraye-par",
      hr: "za-iznajmljivanje",
      hu: "kiado",
      id: "disewa",
      it: "in-affitto",
      ja: "賃貸中",
      ko: "임대중",
      lt: "nuomai",
      lv: "izire",
      ms: "untuk-disewa",
      nl: "te-huur",
      no: "til-leie",
      pl: "do-wynajecia",
      pt: "para-alugar",
      ro: "de-inchiriat",
      ru: "sdayetsya-v-arendu",
      sk: "na-prenajom",
      sl: "v-najemu",
      sr: "za-izdavanje",
      sv: "till-uthyrning",
      sw: "inapangishwa",
      th: "ให้เช่า",
      tl: "upa",
      tr: "kiralik",
      uk: "v-orendu",
      vi: "cho-thue",
      zh: "出租",
    },
  },

  type: {
    "apartment-house": {
      af: "woonstel-huis",
      ar: "شقة-منزل",
      bg: "apartament-kashta",
      cs: "byt-dum",
      da: "lejlighed-hus",
      de: "wohnung-haus",
      el: "diamerisma-spiti",
      en: "apartment-house",
      es: "apartamento-casa",
      et: "korter-maja",
      fi: "huoneisto-talo",
      fr: "appartement-maison",
      he: "דירה-בית",
      hi: "apartment-makan",
      hr: "stan-kuca",
      hu: "lakas-haz",
      id: "apartemen-rumah",
      it: "appartamento-casa",
      ja: "アパート-家",
      ko: "아파트-주택",
      lt: "butas-namas",
      lv: "dzivoklis-maja",
      ms: "pangsapuri-rumah",
      nl: "appartement-huis",
      no: "leilighet-hus",
      pl: "mieszkanie-dom",
      pt: "apartamento-casa",
      ro: "apartament-casa",
      ru: "kvartira-dom",
      sk: "byt-dom",
      sl: "stanovanje-hisa",
      sr: "stan-kuca",
      sv: "lagenhet-hus",
      sw: "nyumba-ya-gorofa",
      th: "อพาร์ตเมนต์-บ้าน",
      tl: "apartment-bahay",
      tr: "daire-ev",
      uk: "kvartyra-budinok",
      vi: "can-ho-nha",
      zh: "公寓-房子",
    },
    apartment: {
      af: "woonstel",
      ar: "شقة",
      bg: "apartament",
      cs: "byt",
      da: "lejlighed",
      de: "wohnung",
      el: "diamerisma",
      en: "apartment",
      es: "apartamento",
      et: "korter",
      fi: "huoneisto",
      fr: "appartement",
      he: "דירה",
      hi: "apartment",
      hr: "stan",
      hu: "lakas",
      id: "apartemen",
      it: "appartamento",
      ja: "アパート",
      ko: "아파트",
      lt: "butas",
      lv: "dzivoklis",
      ms: "pangsapuri",
      nl: "appartement",
      no: "leilighet",
      pl: "mieszkanie",
      pt: "apartamento",
      ro: "apartament",
      ru: "kvartira",
      sk: "byt",
      sl: "stanovanje",
      sr: "stan",
      sv: "lagenhet",
      sw: "fleti",
      th: "อพาร์ตเมนต์",
      tl: "apartment",
      tr: "daire",
      uk: "kvartyra",
      vi: "can-ho",
      zh: "公寓",
    },
    house: {
      af: "huis",
      ar: "منزل",
      bg: "kashta",
      cs: "dum",
      da: "hus",
      de: "haus",
      el: "spiti",
      en: "house",
      es: "casa",
      et: "maja",
      fi: "talo",
      fr: "maison",
      he: "בית",
      hi: "ghar",
      hr: "kuca",
      hu: "haz",
      id: "rumah",
      it: "casa",
      ja: "家",
      ko: "집",
      lt: "namas",
      lv: "maja",
      ms: "rumah",
      nl: "huis",
      no: "hus",
      pl: "dom",
      pt: "casa",
      ro: "casa",
      ru: "dom",
      sk: "dom",
      sl: "hisa",
      sr: "kuca",
      sv: "hus",
      sw: "nyumba",
      th: "บ้าน",
      tl: "bahay",
      tr: "ev",
      uk: "dim",
      vi: "nha",
      zh: "房子",
    },
    land: {
      af: "grond",
      ar: "ارض",
      bg: "zemyа",
      cs: "pozemek",
      da: "jord",
      de: "grundstuck",
      el: "gi",
      en: "land",
      es: "terreno",
      et: "maa",
      fi: "maa",
      fr: "terrain",
      he: "קרקע",
      hi: "zamin",
      hr: "zemljiste",
      hu: "telek",
      id: "tanah",
      it: "terreno",
      ja: "土地",
      ko: "토지",
      lt: "sklypas",
      lv: "zeme",
      ms: "tanah",
      nl: "grond",
      no: "tomt",
      pl: "dzialka",
      pt: "terreno",
      ro: "teren",
      ru: "zemlya",
      sk: "pozemok",
      sl: "zemljisce",
      sr: "zemljiste",
      sv: "tomt",
      sw: "ardhi",
      th: "ที่ดิน",
      tl: "lupa",
      tr: "arsa",
      uk: "zemlya",
      vi: "dat",
      zh: "土地",
    },
    office: {
      af: "kantoor",
      ar: "مكتب",
      bg: "ofis",
      cs: "kancelar",
      da: "kontor",
      de: "buero",
      el: "grafeio",
      en: "office",
      es: "oficina",
      et: "kontor",
      fi: "toimisto",
      fr: "bureau",
      he: "משרד",
      hi: "karyalay",
      hr: "ured",
      hu: "iroda",
      id: "kantor",
      it: "ufficio",
      ja: "オフィス",
      ko: "사무실",
      lt: "biuras",
      lv: "birojs",
      ms: "pejabat",
      nl: "kantoor",
      no: "kontor",
      pl: "biuro",
      pt: "escritorio",
      ro: "birou",
      ru: "ofis",
      sk: "kancelaria",
      sl: "pisarna",
      sr: "kancelarija",
      sv: "kontor",
      sw: "ofisi",
      th: "สำนักงาน",
      tl: "opisina",
      tr: "ofis",
      uk: "ofis",
      vi: "van-phong",
      zh: "办公室",
    },
  },

  location_type: {
    city: {
      af: "stad",
      ar: "مدينة",
      bg: "grad",
      cs: "mesto",
      da: "by",
      de: "stadt",
      el: "poli",
      en: "city",
      es: "ciudad",
      et: "linn",
      fi: "kaupunki",
      fr: "ville",
      he: "עיר",
      hi: "shahar",
      hr: "grad",
      hu: "varos",
      id: "kota",
      it: "citta",
      ja: "都市",
      ko: "도시",
      lt: "miestas",
      lv: "pilseta",
      ms: "bandar",
      nl: "stad",
      no: "by",
      pl: "miasto",
      pt: "cidade",
      ro: "oras",
      ru: "gorod",
      sk: "mesto",
      sl: "mesto",
      sr: "grad",
      sv: "stad",
      sw: "jiji",
      th: "เมือง",
      tl: "lungsod",
      tr: "sehir",
      uk: "misto",
      vi: "thanh-pho",
      zh: "城市",
    },
    region: {
      af: "streek",
      ar: "منطقة",
      bg: "region",
      cs: "region",
      da: "region",
      de: "region",
      el: "perioxi",
      en: "region",
      es: "region",
      et: "piirkond",
      fi: "alue",
      fr: "region",
      he: "אזור",
      hi: "kshetra",
      hr: "regija",
      hu: "regio",
      id: "wilayah",
      it: "regione",
      ja: "地域",
      ko: "지역",
      lt: "regionas",
      lv: "regions",
      ms: "rantau",
      nl: "regio",
      no: "region",
      pl: "region",
      pt: "regiao",
      ro: "regiune",
      ru: "region",
      sk: "region",
      sl: "regija",
      sr: "region",
      sv: "region",
      sw: "eneo",
      th: "ภูมิภาค",
      tl: "rehiyon",
      tr: "bolge",
      uk: "region",
      vi: "khu-vuc",
      zh: "地区",
    },
    country: {
      af: "land",
      ar: "دولة",
      bg: "darzhava",
      cs: "zeme",
      da: "land",
      de: "land",
      el: "chora",
      en: "country",
      es: "pais",
      et: "riik",
      fi: "maa",
      fr: "pays",
      he: "מדינה",
      hi: "desh",
      hr: "drzava",
      hu: "orszag",
      id: "negara",
      it: "paese",
      ja: "国",
      ko: "국가",
      lt: "salis",
      lv: "valsts",
      ms: "negara",
      nl: "land",
      no: "land",
      pl: "kraj",
      pt: "pais",
      ro: "tara",
      ru: "strana",
      sk: "krajina",
      sl: "drzava",
      sr: "drzava",
      sv: "land",
      sw: "nchi",
      th: "ประเทศ",
      tl: "bansa",
      tr: "ulke",
      uk: "krayina",
      vi: "quoc-gia",
      zh: "国家",
    },
    anywhere: {
      af: "oral",
      ar: "في-اي-مكان",
      bg: "navsyakade",
      cs: "kdekoli",
      da: "hvor-som-helst",
      de: "uberall",
      el: "opoudipote",
      en: "anywhere",
      es: "en-cualquier-lugar",
      et: "igal-pool",
      fi: "missa-tahansa",
      fr: "partout",
      he: "בכל-מקום",
      hi: "kahin-bhi",
      hr: "bilo-gdje",
      hu: "barhol",
      id: "dimana-saja",
      it: "ovunque",
      ja: "どこでも",
      ko: "어디든",
      lt: "bet-kur",
      lv: "jebkur",
      ms: "di-mana-saja",
      nl: "overal",
      no: "hvor-som-helst",
      pl: "gdziekolwiek",
      pt: "em-qualquer-lugar",
      ro: "oriunde",
      ru: "gde-ugodno",
      sk: "kdekolvek",
      sl: "kjerkoli",
      sr: "bilo-gde",
      sv: "var-som-helst",
      sw: "popote",
      th: "ที่ใดก็ได้",
      tl: "kahit-saan",
      tr: "her-yer",
      uk: "anywhere",
      vi: "bat-ky-dau",
      zh: "任何地方",
    },
  },
};

export const slugToLocale: Record<string, string> = Object.entries(
  localizedRoutes,
).reduce(
  (acc, [, locales]) => {
    Object.entries(locales).forEach(([locale, slug]) => {
      // only assign if not already mapped
      if (!acc[slug]) acc[slug] = locale;
    });
    return acc;
  },
  {} as Record<string, string>,
);
